import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  container: {
    width: '150%',
    position: 'absolute',
    bottom: 0,
    overflow: 'hidden',
  },
  row: {
    flexDirection: 'row',
  },
});
